var _defs, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarrier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "barrier-stripes",
    width: 36,
    height: 48,
    patternUnits: "userSpaceOnUse",
    patternTransform: "rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 48,
    fill: "#f5b800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 18,
    height: 48,
    fill: "#3d4555"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 12,
    width: 18,
    height: 108,
    rx: 4,
    fill: "#95989c"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 12,
    width: 18,
    height: 108,
    rx: 4,
    fill: "#95989c"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 252,
    height: 20,
    rx: 3,
    fill: "#f7dc5a"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    width: 252,
    height: 48,
    rx: 3,
    fill: "url(#barrier-stripes)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 46,
    width: 252,
    height: 48,
    rx: 3,
    fill: "none",
    stroke: "#2a2a2e",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrier);
export default __webpack_public_path__ + "static/media/barrier.2f12f9538eec4c5d047551bff1139c86.svg";
export { ForwardRef as ReactComponent };